import { useContext, useEffect, useState } from "react";
import { Button, Typography, Col, Skeleton, List } from "antd";
import Mandatory from "shared-components/Components/User/Mandatory/web";
import { useProjectInfo } from "./hook";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";
import { UserStateContext } from "shared-components/Contexts/User/context";
import dynamic from "next/dynamic";
import { useUser } from "shared-components/Components/User/User.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
const Modal = dynamic(() => import("shared-components/Components/Modal/web").then(mod => mod.Modal), { ssr: false });

const ProjectInfo = ({ loading = false, projectId, ...rest }) => {
	const { query } = useRouter();
	const { projectInfoList, sendLead, formCompleted } = useProjectInfo(projectId, rest, query);
	const [asked, setAsked] = useState([]);
	const [userHasAllData, setUserHasAllData] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [fieldToAsk, setFieldToAsk] = useState("");
	const FP = useFacebookPixel();
	const user = useContext(UserStateContext);
	const { isLoggedIn, user: { refetch } } = useUser()
	const { country_code } = useContext(ConfigStateContext);

	useEffect(() => {
		if (formCompleted) {
			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	if (loading) {
		return <Skeleton active />;
	}

	if (!projectInfoList.length) {
		return null;
	}

	useEffect(() => {
		if (country_code !== "CO") {
			setUserHasAllData(true);
		}
		if (country_code === "CO" && user.me) {
			const hasAllData = !!user.me.phone && !!user.me.name;
			setUserHasAllData(hasAllData);
		}

	}, [user.me]);

	const askFastAction = field => {
		sendLead(field)
			.then(res => {
				if (res) {
					setAsked([...asked, field]);
					handleClickShowNotification({ message: "¡Consulta express enviada con éxito!" });
				}
			})
			.catch(error => {
				console.log(error);
			});
	};

	const handleClickShowNotification = async ({ type = 'success', message = '', description = '' }) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(type, message, description);
	};

	const SpanAskFast = ({ field }) => {
		if (asked.some(o => o == field)) {
			return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
		} else {
			return (
				<Button
					type="text"
					ghost={true}
					onClick={() => {
						if (userHasAllData || !isLoggedIn) {
							askFastAction(field);
						} else {
							setFieldToAsk(field);
							setIsModalVisible(true);
						}
					}}
					className="btnQuestion"
				>
					{"¡Pregúntale!"}
				</Button>
			);
		}
	};

	const ProjectInfoItem = ({ title, value, key, show }) => {
		if (!show) return null;
		return (
			<List.Item>
				<Col span={12}>
					<b>{title}</b>
				</Col>
				<Col span={12}>{value ? value : <SpanAskFast field={key} />}</Col>
			</List.Item>
		);
	};

	return (
		<>
			<List
				size="small"
				bordered
				className="project-info"
				dataSource={projectInfoList}
				renderItem={ProjectInfoItem}
			/>
			<Modal
				show={isModalVisible}
				onClose={() => setIsModalVisible(false)}
				height="500px"
			>
				<div className="auth-modal-wrapper">
					<div className="auth-modal">
						<Mandatory
							onOk={() => {
								askFastAction(fieldToAsk);
								setIsModalVisible(false);
								setUserHasAllData(true);
								refetch();
							}}
							user={user}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export { ProjectInfo };
